import $ from 'jquery';
import moment from 'moment';

import ch_collection from 'collections/coachhub';
import contactModel from 'models/contact';


export default ch_collection.extend({
  url: CONTACT_API_URL,
  model: contactModel,
  comparator: function (contact) {
    // sortBy number of milliseconds in the past
    return moment() - moment(contact.get('latest_message').timestamp);
  }
});



// WEBPACK FOOTER //
// ./static/js/collections/contact.js